import { ActionTree } from 'vuex';
import { AxiosError, AxiosResponse } from 'axios';
import {
  ActivateOrderResponse, Basket, OrderActivationDetails, OrderState,
} from './types';
import { RootState } from '../types';
import { ApiEndpointEnum, getApiRequestConfig } from '../../config/network';

export const actions: ActionTree<OrderState, RootState> = {
  fetchBasket({ commit }) {
    commit('basketLoading');

    return this.state.$http.get('basket', getApiRequestConfig(ApiEndpointEnum.PaymentAPI))
      .then((response: AxiosResponse<Basket>) => {
        const payload: Basket = response && response.data;
        commit('basketLoaded', payload);
      }, (error) => {
        commit('basketError');
      });
  },
  activateOrderLater({ commit }): void {
    commit('activateOrderLaterLoading');

    this.state.$http.get('postponeProductActivation', getApiRequestConfig(ApiEndpointEnum.PaymentAPI))
      .then(
        () => commit('activateOrderLaterLoaded'),
        (error) => commit('activateOrderLaterError', error),
      );
  },
  activateOrder({ commit }, details: OrderActivationDetails): void {
    commit('activateOrderLoading');

    this.state.$http.get('activateProduct', getApiRequestConfig(ApiEndpointEnum.PaymentAPI))
      .then(
        (res: AxiosResponse<ActivateOrderResponse>) => commit('activateOrderLoaded', res && res.data),
        (error: AxiosError) => commit('activateOrderError', error),
      );
  },
};
